export default {
  /// <summary>
  /// Xem theo dự toán được giao
  /// </summary>
  Assigned: 1,
  /// <summary>
  /// Xem theo dự toán thực nhận
  /// </summary>
  ActuallyReceived: 2
};
